import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function CasaGrandePage() {
  return <LocationPageTemplate city="Casa Grande" cityShort="Casa Grande" slug="casa-grande" data-id="element-1012" />;
}